import { useDispatch } from "react-redux"
import useValidate from "../../store/hooks/useValidator"
import { closeModal } from "../../store/actions/modalAction"
import { memo, useCallback, useEffect, useMemo, useState } from "react"
import { callApiAction } from "../../store/actions/commonAction"
import { callSnackBar } from "../../store/actions/snackbarAction"
import { SNACK_BAR_VARIETNS } from "../../utils/constants"
import CreateSourceUi from "./CreateSourceUi"
import { CreatesourceApi, sourceFindByIdApi, UpdatesourceApi } from "../../apis/source.api"

const CreateSourceController = ({ callBack = () => { }, id, isModal, handleClick = () => { } }) => {
    const validate = useValidate()
    const dispatch = useDispatch()
    const title = "Source"

    const [loading, setLoading] = useState(false)


    const [fields, setFields] = useState({
        err: '',
        id,
        title: '',

    })

    const [originalDocument, setOriginalDocument] = useState({})


    const validationSchemaForCreate = useMemo(() => ([

        {
            required: true,
            value: fields.title,
            field: 'Source Name',
        }
    ]), [fields])

    const validationSchemaForUpdate = useMemo(() => ([

        {
            required: true,
            value: fields.title,
            field: 'Source Name',
        }
    ]), [fields])


    const createFunction = async () => {
        const validationResponse = validate(validationSchemaForCreate)

        if (validationResponse === true) {


            setLoading(true)
            dispatch(
                callApiAction(
                    async () => await CreatesourceApi(fields),
                    async (response) => {

                        setLoading(false)
                        callBack()
                        dispatch(callSnackBar("Source Created Successfully", SNACK_BAR_VARIETNS.suceess))
                        dispatch(closeModal("source"))
                        handleClick();
                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })

                        dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error))
                    }
                )
            )
        } else {
            setFields({ ...fields, 'err': validationResponse })
        }
    }

    const updateFunction = async () => {
        const validationResponse = validate(validationSchemaForUpdate)
        const updatedData = ({ id })

        for (let field in originalDocument) {

            if (originalDocument[field] && fields[field] && fields[field] !== originalDocument[field]) {
                updatedData[field] = fields[field]
            }
        }

        if (validationResponse === true) {
            setLoading(true)
            dispatch(
                callApiAction(
                    async () => await UpdatesourceApi(updatedData),
                    async (response) => {
                        callBack()
                        setLoading(false)
                        dispatch(callSnackBar("Source Updated Successfully", SNACK_BAR_VARIETNS.suceess))
                        dispatch(closeModal("update"))
                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })
                    }
                )
            )
        } else {
            setFields({ ...fields, 'err': validationResponse })
        }
    }



    const onSubmit = async (e) => {
        e.preventDefault()
        if (id)
            updateFunction()
        else
            createFunction()
    }



    const fetchById = useCallback((id) => {
        setLoading(true)
        dispatch(
            callApiAction(
                async () => await sourceFindByIdApi({ id }),
                async (response) => {
                    setFields(prev => ({ ...prev, ...response }));
                    setOriginalDocument(response)
                    setLoading(false)
                },
                (err) => {
                    setFields(prev => ({ ...prev, err }));
                    setLoading(false)
                }
            )
        )
    }, [dispatch])

    useEffect(() => {
        if (id) {
            fetchById(id)
        }
    }, [id, fetchById])


    return <CreateSourceUi
        title={title}
        isUpdate={id}
        loading={loading}
        fields={fields}
        onSubmit={onSubmit}
        setFields={setFields}
        isModal={isModal}

    />
}
export default memo(CreateSourceController)
